import type { Column, Table } from '@tanstack/react-table';
import type { CSSProperties } from 'react';

export function getFlexTableStyle<T>(_table: Table<T>) {
	return {
		display: 'flex',
		flexDirection: 'column',
		// This min-width can be higher than the user's screen when the table is
		// really large (e.g. 1500px+). Removing it fixes the scrollbar/table going
		// past the user's screen size.
		// minWidth: `${table.totalColumnsMinWidth}px`,
	} satisfies CSSProperties;
}

/**
 * row
 * headerGroup
 * footerGroup
 */
export function getFlexRowStyle<T>(table: Table<T>) {
	return {
		display: 'flex',
		flex: '1 0 auto',
		minWidth: table.getTotalSize(),
	} satisfies CSSProperties;
}

export function getFlexCellStyle<T>(
	{ column }: { column: Column<T> },
	isLast = false,
	growLastCell = true
) {
	return {
		boxSizing: 'border-box',
		flex: isLast && growLastCell ? '1 0 auto' : '0 0 auto',
		width: column.getSize(),
		paddingLeft: column.getPaddingLeft(),
		paddingRight: column.getPaddingRight(),
	} satisfies CSSProperties;
}
